/**
 * Form validation helpers
 *
 * API_TODO: Server-side validation should mirror these rules.
 */

export const validateEmail = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);

export const validatePhone = (v) => /^[\+]?[\d\s\-\(\)]{7,}$/.test(v);

export const isPhoneChar = (v) => /^[\+\d\s\-\(\)]*$/.test(v);

export const validatePassword = (v) => v.length >= 8;

/**
 * Generate initials from a full name
 * @param {string} name
 * @returns {string} e.g. "IE" for "Iwin Ettumanukaran"
 */
export const getInitials = (name) =>
  name
    .split(" ")
    .map((w) => w[0])
    .join("")
    .substring(0, 2)
    .toUpperCase();

/**
 * Generate a URL-safe slug from a name
 * @param {string} name
 * @returns {string} e.g. "iwin-ettumanukaran"
 */
export const nameToSlug = (name) =>
  name.toLowerCase().replace(/\s+/g, "-");

/**
 * Generate vCard string from user data
 * API_TODO: Move vCard generation to backend for .vcf file download
 *
 * @param {Object} user
 * @returns {string} vCard 3.0 format
 */
export const generateVCard = (user) => {
  const parts = user.name.split(" ");
  const firstName = parts[0] || "";
  const lastName = parts.slice(1).join(" ") || "";

  let vcard = `BEGIN:VCARD
VERSION:3.0
FN:${user.name}
N:${lastName};${firstName};;;`;

  if (user.title) vcard += `\nTITLE:${user.title}`;
  if (user.company) vcard += `\nORG:${user.company}`;
  if (user.email) vcard += `\nEMAIL;TYPE=WORK:${user.email}`;
  if (user.phone) vcard += `\nTEL;TYPE=CELL:${user.phone}`;
  if (user.whatsapp && user.whatsapp !== user.phone) {
    vcard += `\nTEL;TYPE=VOICE:${user.whatsapp}`;
  }

  const visibleLinks = (user.links || []).filter((l) => l.visible);
  visibleLinks.forEach((link) => {
    vcard += `\nURL;TYPE=${link.platform.toUpperCase()}:${link.url}`;
  });

  vcard += `\nNOTE:Card from Connekted.in`;
  vcard += `\nEND:VCARD`;
  return vcard;
};
